import axios from 'axios'
import { isBlank } from '../commons.js'
import ApplicationController from './application_controller.js'

export default class ReportsController extends ApplicationController {

  static targets = [
    "clientSelect", "cfilesSelect"
  ]

  connect() {
  }

  client_changed() {
    const client_id = this.clientSelectTarget.value;
    const url = isBlank(client_id) ? "/cfiles/for_client.json" : `/cfiles/for_client.json?client_id=${client_id}`
    this.cfilesSelectTarget.innerHTML = '';
    axios.get(url)
      .then(response => {
        for (const d of response.data) {
          const option = new Option(d.name, d.id);
          this.cfilesSelectTarget.add(option);
        }
      })
  }
}